import { ChangeDetectionStrategy, Component } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { PropertyKind } from '../property'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { PropertyBrowserComponent } from '../property-browser/property-browser.component'

import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderTabGroupRoutingDirective,
} from '@elderbyte/ngx-starter'
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs'

@Component({
  selector: 'app-property-viewer',
  templateUrl: './property-viewer.component.html',
  styleUrls: ['./property-viewer.component.scss'],
  imports: [
    MatTabGroup,
    ElderTabGroupRoutingDirective,
    MatTab,
    MatTabLabel,
    PropertyBrowserComponent,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class PropertyViewerComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public PropertyKind: PropertyKind

  public kinds = Object.values(PropertyKind)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}
}
